module.exports = __webpack_public_path__ + "img/i-sales-admin.27cd60cb.svg";